import type { CSSProperties } from 'react'

/**
 * Strips a button's user-agent chrome so it can carry arbitrary layout styles.
 * Spread it before the component's own style so callers keep the last word.
 */
export const unstyledButton: CSSProperties = {
  background: 'none',
  border: 0,
  padding: 0,
  font: 'inherit',
  color: 'inherit',
  textAlign: 'inherit'
}
